export enum DatesAutofillDialogActions {
    AUTOFILL = 'autofill',
    CANCEL = 'cancel',
}
